import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Section } from "./Section";

const InsightsSection = () => {
  const sectionRef = useRef(null);
  // const { scrollYProgress } = useScroll({
  //   target: sectionRef,
  //   offset: ["start end", "end start"],
  // });

  // const y = useTransform(scrollYProgress, [0, 1], [100, -100]);
  // const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  const insights = [
    {
      title: "Pricing Accessibility:",
      description:
        "Hosts lack user-friendly platform to set competitive prices, leading to a need for accessible systems with insights into market trends and guest preferences",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.3357 16.6671C37.0968 20.4026 36.5544 24.2862 34.7987 27.6701C33.0431 31.0541 30.1805 33.7339 26.6882 35.2627C23.1959 36.7914 19.285 37.0768 15.6078 36.0711C11.9306 35.0654 8.70931 32.8295 6.48111 29.7362C4.25292 26.6429 3.15252 22.8792 3.36343 19.0728C3.57433 15.2664 5.08379 11.6473 7.64007 8.81909C10.1964 5.99089 13.645 4.12452 17.4108 3.53123C21.1766 2.93793 25.032 3.65357 28.334 5.5588"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 18.3327L20 23.3327L36.6667 6.66602"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      position: "left",
    },
    {
      title: "Seasonality Impact:",
      description:
        "Pricing is affected by seasonal and locational demand, requiring hosts to adjust prices during off-peak times and near popular attractions.",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 3.33398V6.66732"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.2168 8.2168L10.5668 10.5668"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.334 20H36.6673"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.7836 8.2168L29.4336 10.5668"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5781 21.0826C26.7832 19.8401 26.6322 18.5649 26.1426 17.4047C25.653 16.2445 24.8447 15.2466 23.8115 14.5268C22.7782 13.8069 21.5622 13.3944 20.3042 13.337C19.0462 13.2796 17.7976 13.5798 16.7031 14.2026"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.6676 36.6667H11.6676C10.0909 36.6663 8.54659 36.2187 7.21411 35.3758C5.88164 34.5328 4.81565 33.3292 4.13995 31.9046C3.46425 30.48 3.20657 28.8929 3.39684 27.3277C3.58711 25.7625 4.21751 24.2834 5.21484 23.0622C6.21217 21.841 7.53549 20.9278 9.03111 20.4286C10.5267 19.9295 12.1333 19.8649 13.6641 20.2423C15.195 20.6197 16.5874 21.4237 17.6796 22.5609C18.7718 23.6981 19.5189 25.1218 19.8342 26.6667H21.6676C22.9937 26.6667 24.2654 27.1935 25.2031 28.1311C26.1408 29.0688 26.6676 30.3406 26.6676 31.6667C26.6676 32.9927 26.1408 34.2645 25.2031 35.2022C24.2654 36.1399 22.9937 36.6667 21.6676 36.6667Z"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      position: "right",
    },
    {
      title: "Guest Expectations:",
      description:
        "Hosts tailor property features to meet guest expectations (e.g., furnishings, location), boosting booking rates and pricing potential.",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 21.666V33.3327C20 34.2167 20.3512 35.0646 20.9763 35.6897C21.6014 36.3148 22.4493 36.666 23.3333 36.666C24.2174 36.666 25.0652 36.3148 25.6904 35.6897C26.3155 35.0646 26.6667 34.2167 26.6667 33.3327"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 3.33398V6.66732"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.9861 21.6667C35.2451 21.6689 35.5011 21.6106 35.7337 21.4966C35.9662 21.3825 36.169 21.2159 36.326 21.0098C36.4829 20.8037 36.5896 20.5638 36.6376 20.3093C36.6857 20.0548 36.6738 19.7925 36.6028 19.5434C35.6575 15.8582 33.513 12.5922 30.5071 10.2601C27.5012 7.9279 23.8048 6.66211 20.0003 6.66211C16.1958 6.66211 12.4994 7.9279 9.49348 10.2601C6.48759 12.5922 4.34306 15.8582 3.39777 19.5434C3.32714 19.7913 3.31498 20.0522 3.36223 20.3056C3.40948 20.559 3.51486 20.798 3.67008 21.0037C3.8253 21.2095 4.02614 21.3765 4.25681 21.4915C4.48747 21.6066 4.74168 21.6665 4.99944 21.6667H34.9861Z"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      position: "left",
    },
    {
      title: "Profitability Balance:",
      description:
        "Hosts struggle to balance profitability with competitiveness, needing tools that factor in operational costs like cleaning and maintenance.",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3333 25.0007H21.6667C22.5507 25.0007 23.3986 24.6495 24.0237 24.0243C24.6488 23.3992 25 22.5514 25 21.6673C25 20.7833 24.6488 19.9354 24.0237 19.3103C23.3986 18.6852 22.5507 18.334 21.6667 18.334H16.6667C15.6667 18.334 14.8333 18.6673 14.3333 19.334L5 28.334"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.666 35.0005L14.3327 32.6671C14.8327 32.0005 15.666 31.6671 16.666 31.6671H23.3327C25.166 31.6671 26.8327 31.0005 27.9993 29.6671L35.666 22.3338C36.3092 21.726 36.6845 20.8876 36.7095 20.0031C36.7345 19.1185 36.4071 18.2603 35.7993 17.6171C35.1916 16.974 34.3532 16.5986 33.4686 16.5736C32.5841 16.5486 31.7258 16.876 31.0827 17.4838L24.0827 23.9838"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33398 26.666L13.334 36.666"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.6673 19.8346C29.3367 19.8346 31.5006 17.6707 31.5006 15.0013C31.5006 12.3319 29.3367 10.168 26.6673 10.168C23.9979 10.168 21.834 12.3319 21.834 15.0013C21.834 17.6707 23.9979 19.8346 26.6673 19.8346Z"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 13.334C12.7614 13.334 15 11.0954 15 8.33398C15 5.57256 12.7614 3.33398 10 3.33398C7.23858 3.33398 5 5.57256 5 8.33398C5 11.0954 7.23858 13.334 10 13.334Z"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      position: "right",
    },
    {
      title: "Privacy Preference:",
      description:
        "Guests prefer entire homes or apartments for privacy, increasing demand and prices for these listings, especially in high-demand locations.",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 36.6673V6.66732C10 5.78326 10.3512 4.93542 10.9763 4.31029C11.6014 3.68517 12.4493 3.33398 13.3333 3.33398H26.6667C27.5507 3.33398 28.3986 3.68517 29.0237 4.31029C29.6488 4.93542 30 5.78326 30 6.66732V36.6673H10Z"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.0007 20H6.66732C5.78326 20 4.93542 20.3512 4.31029 20.9763C3.68517 21.6014 3.33398 22.4493 3.33398 23.3333V33.3333C3.33398 34.2174 3.68517 35.0652 4.31029 35.6904C4.93542 36.3155 5.78326 36.6667 6.66732 36.6667H10.0007"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30 15H33.3333C34.2174 15 35.0652 15.3512 35.6904 15.9763C36.3155 16.6014 36.6667 17.4493 36.6667 18.3333V33.3333C36.6667 34.2174 36.3155 35.0652 35.6904 35.6904C35.0652 36.3155 34.2174 36.6667 33.3333 36.6667H30"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.666 10H23.3327"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.666 16.666H23.3327"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.666 23.334H23.3327"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.666 30H23.3327"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      position: "left",
    },
    {
      title: "Market Fluctuations:",
      description:
        "Hosts face constant market changes, like low demand in off-peak periods, necessitating flexible pricing strategies.",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 5V31.6667C5 32.5507 5.35119 33.3986 5.97631 34.0237C6.60143 34.6488 7.44928 35 8.33333 35H35"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30 28.3333V15"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.666 28.334V8.33398"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.334 28.334V23.334"
            stroke="#0D0D0D"
            strokeWidth="3.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      position: "right",
    },
  ];

  return (
    <motion.section ref={sectionRef} className="w-full" >
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-2xl md:text-3xl lg:text-4xl text-[#D4B896] mb-16 md:mb-20"
      >
        Top 6 Insights
      </motion.h2>

      <div className="relative max-w-7xl mx-auto">
        <div className="absolute left-1/2 top-0 bottom-0 w-0.5 gradient-timeline hidden lg:block transform -translate-x-1/2" />

        <div className="space-y-12 md:space-y-16 lg:space-y-24">
          {insights.map((insight, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                x: insight.position === "left" ? -50 : 50,
              }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`relative grid grid-cols-1 lg:grid-cols-2 gap-6 items-center ${
                insight.position === "right" ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div
                className={`${
                  insight.position === "right"
                    ? "lg:col-start-2"
                    : "lg:col-start-1"
                }`}
              >
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                  className={`flex items-center gap-6 ${
                    insight.position === "left"
                      ? "flex-row-reverse md:flex-row lg:flex-row"
                      : ""
                  }`}
                >
                  <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-2xl border-4 border-dark gradient-gold shadow-xl flex items-center justify-center">
                    {insight.icon}
                  </div>
                  <div className="flex-1 top-insights-glass-card rounded-3xl p-6 md:p-8">
                    <h3 className="text-[#D4B896] text-lg md:text-xl mb-3">
                      {insight.title}
                    </h3>
                    <p className="text-muted-text text-sm md:text-base leading-relaxed">
                      {insight.description}
                    </p>
                  </div>
                </motion.div>
              </div>

              <div className="hidden lg:block absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-coral border-4 border-dark">
                <div className="h-full w-full bg-[#FD5B38] rounded-full"></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

const PersonaCard = ({
  name,
  role,
  quote,
  age,
  status,
  location,
  traits,
  image,
}) => {
  return (
    <div className="top-insights-glass-card rounded-3xl p-6 md:p-8 space-y-6">
      <div className="gradient-coral-border rounded-2xl p-6 md:p-8 space-y-6">
        <h3 className="text-white text-xl md:text-2xl">{name}</h3>

        <div className="bg-white/90 rounded-2xl p-4 shadow-xl">
          <img
            src={image}
            alt={name}
            className="w-full h-80 object-cover rounded-lg"
          />
        </div>

        <p className="text-white text-lg md:text-xl">{role}</p>
        <p className="text-muted-text text-sm md:text-base italic">"{quote}"</p>
      </div>

      <div className="gradient-coral rounded-2xl p-6 md:p-8 space-y-4 shadow-xl">
        <p className="text-white/90 text-base md:text-lg">{age}</p>
        <p className="text-white/90 text-base md:text-lg">{status}</p>
        <p className="text-white/90 text-base md:text-lg">{location}</p>
        <div className="flex flex-wrap gap-3">
          {traits.map((trait, idx) => (
            <span
              key={idx}
              className="px-4 py-2 bg-white/95 rounded-full text-dark text-sm md:text-base shadow-md"
            >
              {trait}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

const DetailSection = ({ title, items }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="top-insights-glass-card rounded-3xl p-6 md:p-8 space-y-4 h-max"
    >
      <div className="flex items-center gap-3">
        <div className="w-1 h-6 bg-[#FD5B38] rounded-full" />
        <h3 className="text-white text-lg md:text-xl">{title}</h3>
      </div>
      <ul className="space-y-3">
        {items.map((item, idx) => (
          <motion.li
            key={idx}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1 }}
            className="flex items-start gap-3"
          >
            <span className="text-[#FD5B38] text-xl mt-1">•</span>
            <span className="text-muted-text text-sm md:text-base leading-relaxed flex-1">
              {item}
            </span>
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
};

export default function TopInsights() {
  const heroRef = useRef(null);
  // const { scrollYProgress } = useScroll({
  //   target: heroRef,
  //   offset: ["start start", "end start"],
  // });

  // const heroY = useTransform(scrollYProgress, [0, 1], [0, 200]);
  // const heroOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [1, 0.5, 0]);

  return (
    <>
      <Section>
        <motion.div
          ref={heroRef}
          // style={{ y: heroY, opacity: heroOpacity }}
          className="relative"
        >
          <InsightsSection />
        </motion.div>
      </Section>
      <Section className="w-full">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl lg:text-5xl text-white mb-16 md:mb-20"
        >
          User Persona
        </motion.h1>

        <div className="space-y-24 md:space-y-32 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-1 lg:grid-cols-3 gap-8"
          >
            <PersonaCard
              name="Sarah"
              role="Tech Savvy/Part-time Airbnb Host"
              quote="Suburban area, Managing a single property Listing"
              age="Age: 28"
              status="Status: Single"
              location="Location: San Francisco, California"
              traits={["Friendly", "Loyal", "Patience", "Supportive"]}
              image="/assets/imgs/case-studies/ipm_29.png"
            />

            <div className="grid grid-cols-1 gap-4">
              <DetailSection
                title="Goals"
                items={[
                  "Set competitive yet profitable prices that attract guests.",
                  "Create a positive guest experience to earn good reviews and build hosting credibility.",
                  "Gain confidence in managing her Airbnb listing and pricing strategy.",
                ]}
              />

              <DetailSection
                title="Needs"
                items={[
                  "Beginner-friendly pricing tools that are simple and intuitive.",
                  "Seasonal pricing guidance to help maintain occupancy during off-peak periods.",
                  "Affordable amenities ideas that enhance guest satisfaction.",
                ]}
              />

              <DetailSection
                title="Attitudes/Interest"
                items={[
                  "Revenue-driven: Focuses on pricing strategies to maximize earnings.",
                  "Guest-experience oriented: Ensures listings meet guest expectations for high ratings.",
                  "Market-aware: Keeps up with industry trends to stay competitive.",
                  "Efficient: Looks for tools and strategies that save time while enhancing management.",
                ]}
              />
            </div>

            <div className="grid grid-cols-1 gap-4">
              <DetailSection
                title="Behaviour Summary"
                items={[
                  "Updates her listing often based on guest feedback to enhance appeal.",
                  "Attempts to adjust pricing based on perceived demand, but lacks confidence in her choices.",
                  "Invests in small, thoughtful touches for guests (e.g., guidebooks, local recommendations).",
                ]}
              />

              <DetailSection
                title="Frustrations"
                items={[
                  "Finds existing pricing tools overwhelming, leading to uncertainty in setting the right rates.",
                  "Struggles to balance guest affordability with covering essential expenses like cleaning.",
                  "Lacks clarity on what amenities will most enhance guest satisfaction, leading to hesitation in making changes.",
                ]}
              />
              <DetailSection
                title="Pain Points"
                items={["Uncertainty", "Inexperience", "Pricing"]}
              />
            </div>
          </motion.div>
          {/* Mark */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-1 lg:grid-cols-3 gap-8"
          >
            <PersonaCard
              name="Mark"
              role="Full-time Airbnb Host with Multiple Properties"
              quote="Urban and city-center areas, managing several High-demand Listings"
              age="Age: 45"
              status="Status: Married"
              location="Location: Dallas/Texas"
              traits={["Supportive", "Loyal", "Protective", "Responsible"]}
              image="/assets/imgs/case-studies/ipm_30.png"
            />

            <div className="grid grid-cols-1 gap-4">
              <DetailSection
                title="Goals"
                items={[
                  "Maximize revenue by setting rates aligned with market demand.",
                  "Maintain high occupancy rates, especially during off-peak seasons.",
                  "Meet diverse guest expectations to receive high ratings and repeat bookings.",
                ]}
              />

              <DetailSection
                title="Needs"
                items={[
                  "Advanced, data-driven pricing tools with competitor insights and market trends.",
                  "Automated pricing adjustments to streamline management across multiple properties.",
                  "Resources to optimize maintenance costs without sacrificing guest experience.",
                ]}
              />

              <DetailSection
                title="Attitudes/Interest"
                items={[
                  "Guest-focused: Values creating a welcoming experience to receive positive feedback.",
                  "Learning-oriented: Eager to learn about hosting best practices and improve her listings.",
                  "Cost-conscious: Carefully considers expenses to balance quality with affordability.",
                  "Curious: Experimenting with new strategies to understand what works best for guests.",
                ]}
              />
            </div>

            <div className="grid grid-cols-1 gap-4">
              <DetailSection
                title="Behaviour Summary"
                items={[
                  "Regularly monitors competitor rates and adjusts prices to maintain an edge.",
                  "Updates listings with amenities that align with guest preferences for better reviews.",
                  "Uses guest feedback to continuously improve property features and services.",
                ]}
              />

              <DetailSection
                title="Frustrations"
                items={[
                  "Time-consuming process of manually adjusting seasonal pricing across multiple properties.",
                  "High operational costs make it challenging to keep prices competitive.",
                  "Diverse guest needs require frequent adjustments to listings, adding to management complexity.",
                ]}
              />
              <DetailSection
                title="Pain Points"
                items={["Fluctuations", "Workload", "Costs"]}
              />
            </div>
          </motion.div>
        </div>
      </Section>
    </>
  );
}
